"use client";
import { PaylioContext } from "@/context/context";
import { useContext } from "react";
import { BsMoonStars, BsSun } from "react-icons/bs";

export default function ThemeToggle() {
  const { workspaceTheme, toggleWorkspaceTheme } = useContext(PaylioContext);
  const isDark = workspaceTheme === "dark";

  return (
    <button
      type="button"
      className="workspace-theme-toggle"
      onClick={toggleWorkspaceTheme}
      title={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}>
      {isDark ? <BsSun size={20} /> : <BsMoonStars size={20} />}
    </button>
  );
}
